import Buttons from '@/component/popups/Buttons';
import PopupFrame from '@/component/popups/ui-1';
import imgDontLoseYourStreak from '@assets/web-v3-images/not-lowest-unique.png';
import { Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

export default function Confirmation({
	open,
	onOpenChange,
	handleClick,
	value = 0,
	productName = ''
}
) {
	const { t } = useTranslation()
	return (
		<PopupFrame
			open={open}
			onOpenChange={onOpenChange}
			title={t("confirmation")}
			classNames='sm:!max-w-[600px]'
		>
			<div className=" flex flex-col items-center justify-center">

				<div className="flex justify-center px-10 sm:px-15 md:px-30 lg:px-30 xl:px-35 pt-5">
					<img
						src={imgDontLoseYourStreak}
						alt="turns"
						className="w-[120px] sm:w-[160px] md:w-[220px] lg:w-[220px] xl:w-[220px] h-auto"
					/>
				</div>
				<Text
					as="p"
					className="text-[#A15C07] font-medium text-[13px] sm:text-[19px] text-center pt-6 sm:px-5"
				>
					{t("daily_reward.confirm_to_guess_the_price_xxx_MMK_for_the_xxx")
						.replace("_LP2_", value)
						.replace("_LP1_", productName)}
				</Text>

				<div className="flex gap-3 justify-between pt-5">
					<Buttons
						handleClick={() => onOpenChange(false)}
						textBtn={t("daily_reward.cancel")}
						classItem="!m-0"
						classItemText='!text-[14px] sm:!text-[20px]'
					/>
					<Buttons
						handleClick={handleClick}
						textBtn={t("daily_reward.confirm")}
						classItem="!m-0"
						classItemText='!text-[14px] sm:!text-[20px]'
					/>
				</div>
			</div>
		</PopupFrame>
	)
}
